import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr13 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа в сервизни работилници
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. До работа в сервизни работилници </b>се допускат само лица, които са преминали
        съответното обучение и инструктаж за безопасна работа.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При работа задължително </b>да се използват одобрените и предоставени съобразно
        степента на риска лични предпазни средства, за вида, употребата и начина на съхранение на
        които работещите са инструктирани (и обучени за използването на тези ЛПС, за които това е
        необходимо).
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. <span>Забранява се </span>
        </b>
        работа с неизправни лични предпазни средства и с такива с изтекъл срок на годност и на
        периодична проверка.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          4. <span style={styles.warning}>Забранява се </span>
        </b>
        работата с неизправни и не обезопасени механични и електрически инструменти.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          5. <span style={styles.warning}>Забранява се </span>
        </b>
        извършването на ремонтни и профилактични работи, когато съоръженията са под напрежение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          6. <span>Забранява се </span>
        </b>
        поставянето на работното място на открити превключвателни клеми и други елементи за
        електромонтаж, които се намират под напрежение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. Съоръженията, апаратурите и частите</b>, които подлежат на ремонт или са ремонтирани
        да се подреждат така, че да не създават предпоставки за злополуки.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8. Работните маси да бъдат </b>с изолационно покритие.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. Електрическите поялници при работа</b> да се поставят на специални метални поставки.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. Запояването да се извършва</b> при осигурено проветряване.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. След запояване с припой, съдържащ олово</b>, работниците задължително да измиват
        ръцете обилно със сапун и 1% разтвор на оцетна киселина.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          12. <span style={styles.warning}>Забранява се </span>
        </b>
        хранене и съхраняване на вода и хранителни продукти в помещения, в които се запоява.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13. Персоналът да е запознат с начина</b> на гасене и безопасната работа с
        пожарогасителните уреди, с които е оборудван обекта.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr13;
